


class Pager {

	constructor(pageSize) {
		this.pageSize = pageSize;
		this.reset();
	}

	reset() {
		this.lastItem = 0;
		this.ended = false;
		this.currentPage = 0;
		this.totalItems = 0;
	}

	updateHeader(header) {
		let data = header.split("=")[1].split("/");
		let items = data[0].split("-");
		
		let totalItems = data[1] === "*" ? -1 : parseInt(data[1]);
		let startItem = parseInt(items[0]);
		let endItem = parseInt(items[1]);

		this.update(startItem,endItem,totalItems)
	}

	update(newItems, totalItems) {
		this.lastItem = this.lastItem + newItems;
		this.totalItems = totalItems;

		if (newItems === 0 || this.lastItem === this.totalItems) {
			this.ended = true;
		}

		this.currentPage = (this.lastItem / this.pageSize);
	}

	getNextPage() {
		let nextStartItem = this.currentPage * this.pageSize;
		let nextEndItem = (this.currentPage+1) * this.pageSize - 1;
		return { startItem: nextStartItem, endItem: nextEndItem}
	}

	getNextHeader() {
		let page = this.getNextPage();
		return `items=${page.startItem}-${page.endItem}`
	}

	getInfinitePage() {
		return { startItem: 0, endItem: 32767 }
	} 
	

}

export default Pager;
